import React, {Fragment} from 'react'
import Header from '../components/Header'
import Hero from '../components/Contact/Hero'
import Content from '../components/Contact/Content'
import Footer from '../components/Footer'

class ContactUs extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <Fragment>
                <Header logoColor="#46e2b9"  classStatic="" dropDownColor="black" title="Albert"/>
                <Hero/>
                <Content />
                <Footer/>
            </Fragment>
        )
    }
}

export default ContactUs;